import { render, staticRenderFns } from "./ProductCardH.vue?vue&type=template&id=8937afac&scoped=true&"
import script from "./ProductCardH.vue?vue&type=script&lang=js&"
export * from "./ProductCardH.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardH.vue?vue&type=style&index=0&id=8937afac&prod&lang=scss&scoped=true&"
import style1 from "./ProductCardH.vue?vue&type=style&index=1&id=8937afac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8937afac",
  null
  
)

export default component.exports
import QImg from 'quasar/src/components/img/QImg.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QInfiniteScroll from 'quasar/src/components/infinite-scroll/QInfiniteScroll.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QImg,QBadge,QSkeleton,QBtn,QIcon,QDialog,QInfiniteScroll});
